<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <!-- HEADER -->
      <div class="modal-header">
        <h2>Thêm sản phẩm</h2>
        <button @click="$emit('close')">✖</button>
      </div>

      <!-- TABS -->
      <div class="tabs">
        <button :class="{ active: tab === 'general' }" @click="tab = 'general'">
          Thông tin
        </button>
        <button :class="{ active: tab === 'price' }" @click="tab = 'price'">
          Giá & Kho
        </button>
        <button
          :class="{ active: tab === 'advanced' }"
          @click="tab = 'advanced'"
        >
          Nâng cao
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">
        <!-- TAB 1 -->
        <div v-if="tab === 'general'" class="grid">
          <div class="form-group">
            <label class="required" for="">Tên hàng</label>
            <input
              v-model="form.ten_hang"
              placeholder="Tên hàng"
              :class="error.ten_hang ? 'error' : ''"
              @input="delete error.ten_hang"
            />
            <span v-if="error.ten_hang" class="error-message">
              {{ error.ten_hang }}
            </span>
          </div>

          <div class="form-group">
            <label for="">Mã vạch</label>
            <input v-model="form.ma_vach" placeholder="Mã vạch" />
          </div>
          <div class="form-group">
            <label for="">Thương hiệu</label>
            <input v-model="form.thuong_hieu" placeholder="Thương hiệu" />
          </div>

          <div class="form-group">
            <label for="">Loại hàng</label>
            <select v-model="form.loai_hang" name="" id="">
              <option value="">-- Chọn loại hàng --</option>
              <option value="Linh kiện">Linh kiện</option>
              <option value="Hàng hoá">Hàng hoá</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Nhà cung cấp</label>
            <select v-model="form.nha_cung_cap">
              <option value="">-- Chọn nhà cung cấp --</option>
              <option v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id">
                {{ supplier.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Nhóm hàng</label>
            <input v-model="form.nhom_hang" placeholder="Nhóm hàng" />
          </div>

          <div class="form-group">
            <label for="">Mô tả</label>
            <textarea v-model="form.mo_ta" placeholder="Mô tả"></textarea>
          </div>

          <!-- upload ảnh -->
          <div class="form-group">
            <label for="">Hình ảnh</label>
            <input type="file" @change="handleImage" />
            <img v-if="preview" :src="preview" class="preview" />
          </div>
        </div>

        <!-- TAB 2 -->
        <div v-if="tab === 'price'" class="grid">
          <div class="form-group">
            <label for="" class="required">Giá bán</label>
            <input
              type="text"
              v-model="giaBanDisplay"
              placeholder="Giá bán"
              :class="error.gia_ban ? 'error' : ''"
              @input="delete error.gia_ban"
            />
            <span v-if="error.gia_ban" class="error-message">
              {{ error.gia_ban }}
            </span>
          </div>
          <div class="form-group">
            <label class="required" for="">Giá vốn</label>
            <input
              type="text"
              v-model="giaVonDisplay"
              placeholder="Giá vốn"
              :class="error.gia_von ? 'error' : ''"
              @input="delete error.gia_von"
            />
            <span v-if="error.gia_von" class="error-message">
              {{ error.gia_von }}
            </span>
          </div>
          <div class="form-group">
            <label for="">Tồn kho</label>
            <input type="number" v-model="form.ton_kho" placeholder="Tồn kho" />
          </div>
          <div class="form-group">
            <label for="">Tồn nhỏ nhất</label>
            <input
              type="number"
              v-model="form.ton_nho_nhat"
              placeholder="Tồn nhỏ nhất"
            />
          </div>
          <div class="form-group">
            <label for="">Tồn lớn nhất</label>
            <input
              type="number"
              v-model="form.ton_lon_nhat"
              placeholder="Tồn lớn nhất"
            />
          </div>

          <div class="form-group">
            <label for="">Đơn vị tính</label>
            <input v-model="form.dvt" placeholder="Đơn vị tính" />
          </div>
          <div class="form-group">
            <label for="">Mã ĐVT cơ bản</label>
            <input v-model="form.ma_dvt_co_ban" placeholder="Mã ĐVT cơ bản" />
          </div>
          <div class="form-group">
            <label for="">Quy đổi</label>
            <input v-model="form.quy_doi" placeholder="Quy đổi" />
          </div>
        </div>

        <!-- TAB 3 -->
        <div v-if="tab === 'advanced'" class="grid">
          <div class="form-group">
            <label for="">Thuộc tính</label>
            <input v-model="form.thuoc_tinh" placeholder="Thuộc tính" />
          </div>

          <div class="form-group">
            <label for="">Mã HH liên quan</label>
            <input
              v-model="form.ma_hh_lien_quan"
              placeholder="Mã HH liên quan"
            />
          </div>

          <div class="form-group">
            <label for="">Trọng lượng</label>
            <input v-model="form.trong_luong" placeholder="Trọng lượng" />
          </div>
          <div class="form-group">
            <label for="">Serial / IMEI</label>
            <input
              v-model="form.serial_imei"
              placeholder="Serial / IMEI"
            />
          </div>

          <div class="form-group">
            <label for="">Vị trí</label>
            <input v-model="form.vi_tri" placeholder="Vị trí" />
          </div>
          <div class="form-group">
            <label class="required" for="">Bảo hành</label>
            <input
              v-model="form.bao_hanh"
              placeholder="Bảo hành"
              :class="error.bao_hanh ? 'error' : ''"
              @input="delete error.bao_hanh"
            />
            <span v-if="error.bao_hanh" class="error-message">
              {{ error.bao_hanh }}
            </span>
          </div>

          <div class="form-group">
            <label for="">Bảo trì định kỳ</label>
            <input
              v-model="form.bao_tri_dinh_ky"
              placeholder="Bảo trì định kỳ"
            />
          </div>

          <!-- checkbox -->
          <label
            ><input type="checkbox" v-model="form.su_dung_imei" /> Sử dụng
            IMEI</label
          >
          <label
            ><input type="checkbox" v-model="form.dang_kinh_doanh" /> Đang kinh
            doanh</label
          >
          <label
            ><input type="checkbox" v-model="form.duoc_ban_truc_tiep" /> Bán
            trực tiếp</label
          >
        </div>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer">
        <button class="btn-save" @click="handleSave">Lưu</button>
        <button @click="$emit('close')">Huỷ</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useToast } from "@/composables/useToast";
import { adminApi, supplierApi } from "@/services/api";
import { formatCurrency, parseCurrency } from "@/utils/helpers";
import { computed, onMounted, reactive, ref } from "vue";

const suppliers = ref([]);
const emit = defineEmits(["save"]);
const toast = useToast();
const loading = ref(false);
const tab = ref("general");
const error = ref({});
const initialForm = ref({
  ten_hang: "",
  ma_hang: "",
  ma_vach: "",
  thuong_hieu: "",
  loai_hang: "",
  nha_cung_cap: "",
  nhom_hang: "",
  mo_ta: "",

  gia_ban: 0,
  gia_von: 0,
  ton_kho: 1,
  ton_nho_nhat: 0,
  ton_lon_nhat: 99999,

  dvt: "",
  ma_dvt_co_ban: "",
  quy_doi: 1,

  thuoc_tinh: "",
  ma_hh_lien_quan: "",
  trong_luong: "",
  serial_imei: "",
  vi_tri: "",
  bao_hanh: "",
  bao_tri_dinh_ky: "",

  su_dung_imei: false,
  dang_kinh_doanh: true,
  duoc_ban_truc_tiep: true,

  hinh_anh: null,
});

const form = reactive({ ...initialForm.value });

const preview = ref(null);
const handleImage = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  form.hinh_anh = file;
  preview.value = URL.createObjectURL(file);
};

const giaBanDisplay = computed({
  get() {
    return formatCurrency(form.gia_ban);
  },
  set(val) {
    form.gia_ban = parseCurrency(val);
  },
});
const giaVonDisplay = computed({
  get() {
    return formatCurrency(form.gia_von);
  },
  set(val) {
    form.gia_von = parseCurrency(val);
  },
});

const validateForm = () => {
  error.value = {};
  let isValid = true;

  if (!form.ten_hang) {
    error.value.ten_hang = "Vui lòng nhập tên hàng hoá";
    isValid = false;
  }
  if (!form.gia_ban) {
    error.value.gia_ban = "Vui lòng nhập giá bán";
    isValid = false;
  }
  if (!form.gia_von) {
    error.value.gia_von = "Vui lòng nhập giá vốn";
    isValid = false;
  }
  if (!form.bao_hanh) {
    error.value.bao_hanh = "Vui lòng nhập thời hạn bảo hành";
    isValid = false;
  }

  return isValid;
};

const fetchSuppliers = async () => {
  try {
    const response = await supplierApi.getSuppliers();
    suppliers.value = response.data.data.data;
  } catch (error) {
    toast.error("Lỗi khi tải danh sách nhà cung cấp");
  }
};

const handleSave = async () => {
  const formData = new FormData();
  Object.keys(form).forEach((key) => {
    let value = form[key];
    if (value === null || value === undefined) value = "";
    if (typeof value === "boolean") value = value ? 1 : 0;
    formData.append(key, value);
  });
  if (validateForm()) {
    loading.value = true;
    try {
      await adminApi.createProduct(formData);
      toast.success("Thêm sản phẩm thành công");
      emit("save");
    } catch (error) {
      if (error.response && error.response.status === 422) {
        error.value = error.response.data.errors;
      }
      const errorMessage = error.response.data.error || "Lỗi khi thêm sản phẩm";
      toast.error(errorMessage);
    } finally {
      loading.value = false;
    }
  }
};

onMounted(() => {
  fetchSuppliers();
});
</script>
<style scoped>
.tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
}

.tabs button {
  padding: 10px 20px;
  cursor: pointer;
}

.tabs button.active {
  border-bottom: 2px solid #42b983;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 15px;
}

.preview {
  width: 100px;
  margin-top: 10px;
}
</style>
